const LOCALE_STORAGE_KEY = 'fc-eligibility-locale';
export const DEFAULT_LOCALE = 'en-US';

function getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
}

export function detectLocale(): string {
    const fcmenuLocale = getCookie('fcmenu-locale');
    if (fcmenuLocale) return fcmenuLocale.replace('_', '-');

    const savedLocale = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (savedLocale) return savedLocale;

    if (navigator.language) return navigator.language;

    return DEFAULT_LOCALE;
}

export function saveLocalePreference(locale: string): void {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
}

export const SUPPORTED_LOCALES: { code: string; label: string }[] = [
    { code: 'en-US', label: 'English' },
    { code: 'ja-JP', label: '日本語' },
    { code: 'de-DE', label: 'Deutsch' },
    { code: 'fr-FR', label: 'Français' },
    { code: 'es-ES', label: 'Español' },
    { code: 'pt-BR', label: 'Português' },
    { code: 'zh-CN', label: '中文' },
    { code: 'ko-KR', label: '한국어' },
    { code: 'ar-SA', label: 'العربية' },
    { code: 'hi-IN', label: 'हिन्दी' },
    { code: 'it-IT', label: 'Italiano' },
    { code: 'nl-NL', label: 'Nederlands' },
    { code: 'pl-PL', label: 'Polski' },
    { code: 'sv-SE', label: 'Svenska' },
    { code: 'th-TH', label: 'ไทย' },
    { code: 'tr-TR', label: 'Türkçe' },
    { code: 'vi-VN', label: 'Tiếng Việt' },
];
